// Normalise les libellés de taille (6 formats dans le catalogue) : même règle que
// Projets/DHD/export/crawl-com-2026-09-24/sizes_parse.py, testée sur les mêmes cas.
(function (root) {
  var FR = '\\d+(?:\\s+\\d+/\\d+)?|\\d+/\\d+';
  var RX = new RegExp(
    '^\\s*(\\d)\\s*[\'’]\\s*(\\d{1,2})"?[\\s\\-–x@]*?(' + FR + ')"?\\s*(?:x|\\s)\\s*(' + FR + ')"?' +
    '(?:\\s*[/\\-@]\\s*(\\d+(?:\\.\\d+)?)\\s*L?)?(.*)$'
  );

  function parse(s) {
    var m = RX.exec(String(s).replace(/[ \t]/g, ' '));
    if (!m) return null;
    return {
      length: m[1] + "'" + m[2],
      width: m[3].trim(),
      thickness: m[4].trim(),
      volume: m[5] ? parseFloat(m[5]) : null,
      note: m[6].replace(/^[\s\-*]+/, '').trim()
    };
  }
  root.bdrParseSize = parse;
  if (typeof customElements === 'undefined' || customElements.get('bdr-size-table')) return;

  // Sans JS ou si le libellé ne se lit pas, la ligne garde le libellé brut sur 4 colonnes.
  class BdrSizeTable extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-bdr-size-raw]').forEach(row);
    }
  }
  customElements.define('bdr-size-table', BdrSizeTable);

  function row(tr) {
    var p = parse(tr.getAttribute('data-bdr-size-raw'));
    if (!p) return;
    var cells = [p.length, p.width + '"', p.thickness + '"', p.volume ? p.volume + ' L' : '–'];
    tr.replaceChildren();
    cells.forEach(function (v, i) {
      var c = document.createElement(i ? 'td' : 'th');
      c.textContent = v;
      if (!i) {
        c.scope = 'row';
        if (p.note) {
          var s = document.createElement('small');
          s.textContent = p.note;
          c.append(' ', s);
        }
      }
      tr.appendChild(c);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
